<template>
    <div>
        <v-row v-masonry>
            <v-col cols="12" sm="6" lg="4">
                <v-card class="soli-round">
                    <v-container>
                        <v-card-title class="soli-grey">
                            Relationships
                        </v-card-title>
                        <v-card-subtitle>
                            <v-btn
                                @click="relationshipForm = true"
                                :disabled="
                                    !user.email &&
                                    !relationships.find((e) => e.email)
                                "
                                x-small
                                outlined
                                class="soli-round soli-blue-text"
                                >Add Relationship</v-btn
                            ></v-card-subtitle
                        >
                        <v-container
                            ><UserRelationships
                                :user="user"
                                :relationships="relationships"
                                :sharedSubscriptions="sharedSubscriptions"
                                @change="redrawVueMasonry"
                                @success="$emit('success')"
                            ></UserRelationships>
                        </v-container> </v-container
                ></v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="4">
                <v-card class="soli-round">
                    <v-container>
                        <v-card-title class="soli-grey">
                            Passes and Memberships
                        </v-card-title>
                        <v-card-subtitle>
                            <v-btn
                                v-if="
                                    can('Work') &&
                                    $page.props.staffView &&
                                    !!user.email
                                "
                                x-small
                                outlined
                                class="soli-round soli-blue-text"
                                @click="
                                    user.email
                                        ? visitStore()
                                        : (showEmailAlert = 'purchase')
                                "
                            >
                                Make a Purchase
                            </v-btn>
                        </v-card-subtitle>
                        <UserSubscription
                            :key="refreshTransactions"
                            :user="user"
                            :sharedSubscriptions="sharedSubscriptions"
                            :relationships="relationships"
                            :errors="errors"
                            @change="redrawVueMasonry"
                            @success="[$emit('success'), refreshTransactions++]"
                        ></UserSubscription> </v-container
                ></v-card>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                lg="4"
                v-if="
                    (user.id == $page.props.auth.user.id ||
                        $page.props.staffView) &&
                    !!user.email
                "
            >
                <v-card class="soli-round">
                    <v-container>
                        <v-card-title class="soli-grey">
                            Billing
                            <div
                                v-if="user.defaultPaymentMethod"
                                class="ml-3 align-center flex caption"
                            >
                                <v-icon small class="soli-blue-text"
                                    >credit_card</v-icon
                                >
                                {{
                                    `${user.defaultPaymentMethod.brand}${user.defaultPaymentMethod.last4}`
                                }}
                            </div>
                        </v-card-title>
                        <v-card-subtitle v-if="user.stripe_id">
                            <v-btn
                                v-if="
                                    can('Issue refunds and credits') &&
                                    $page.props.staffView &&
                                    billingLoaded
                                "
                                x-small
                                outlined
                                class="soli-round soli-blue-text"
                                @click="
                                    $refs.transactions.showCreditForm = true
                                "
                            >
                                Adjust Balance
                            </v-btn>
                            <v-btn
                                x-small
                                outlined
                                @click="visitBillingPortal()"
                                class="soli-round soli-blue-text"
                                v-if="billingLoaded"
                            >
                                Payment Methods</v-btn
                            >
                            <v-btn
                                v-if="can('Work') && $page.props.staffView"
                                x-small
                                outlined
                                class="soli-round soli-blue-text"
                                @click="
                                    user.email
                                        ? ($refs.transactions.showGiftForm = true)
                                        : (showEmailAlert = 'purchase')
                                "
                            >
                                Redeem Code
                            </v-btn>
                        </v-card-subtitle>
                        <v-card-subtitle v-else>
                            <v-btn
                                x-small
                                outlined
                                @click="
                                    user.email
                                        ? addCreditCard()
                                        : (showEmailAlert = 'billing')
                                "
                                class="soli-round soli-blue-text"
                            >
                                Add Payment Method</v-btn
                            ></v-card-subtitle
                        >
                        <UserTransactions
                            v-if="user.stripe_id"
                            :user="user"
                            @change="redrawVueMasonry"
                            @hook:updated="redrawVueMasonry"
                            @success="$emit('success')"
                            @billingLoaded="billingLoaded = $event"
                            :errors="errors"
                            ref="transactions"
                            :key="refreshTransactions"
                        ></UserTransactions> </v-container
                ></v-card>
            </v-col>
            <v-col
                v-if="enrollmentHistory.length && $page.props.auth.staffView"
                cols="12"
                sm="6"
                lg="4"
            >
                <v-card class="soli-round">
                    <v-container>
                        <v-card-title class="soli-grey">
                            Enrollment History
                        </v-card-title>
                        <!--<v-card-subtitle class="caption">
                            Student Since:
                            {{ enrollmentHistory[0]?.start }}
                        </v-card-subtitle>-->
                        <v-container
                            ><UserEnrollmentHistory
                                :user="user"
                                :enrollmentHistory="enrollmentHistory"
                            />
                        </v-container> </v-container
                ></v-card>
            </v-col>
        </v-row>
        <ManageRelationships
            v-if="relationshipForm"
            :user="user"
            :relationships="relationships"
            @success="
                [$emit('success'), closeModal(() => (relationshipForm = false))]
            "
            @reset="relationshipForm = false"
        ></ManageRelationships>
        <SoliChoice
            v-if="showEmailAlert"
            button1="Okay"
            title="Error"
            :subtitle="`User must have an email address to ${
                showEmailAlert == 'purchase'
                    ? 'make a purchase'
                    : showEmailAlert == 'billing'
                    ? 'enable billing'
                    : 'redeem a gift certificate'
            }`"
            @reset="showEmailAlert = null"
        ></SoliChoice>
    </div>
</template>

<script>
import UserSubscription from "./UserSubscription";
import UserRelationships from "./UserRelationships";
import ManageRelationships from "./ManageRelationships";
import UserTransactions from "./UserTransactions";
import UserEnrollmentHistory from "./UserEnrollmentHistory";
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    props: {
        user: {},
        errors: {},
        relationships: {
            type: Array,
            default: null,
        },
        sharedSubscriptions: {
            type: Array,
            default: null,
        },
        enrollmentHistory: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        UserSubscription,
        UserRelationships,
        ManageRelationships,
        UserTransactions,
        UserEnrollmentHistory,
    },
    data() {
        return {
            relationshipForm: false,
            loading: false,
            showEmailAlert: null,
            billingLoaded: false,
            refreshTransactions: 0,
        };
    },
    methods: {
        visitBillingPortal() {
            window.location.href = `${this.user.billingPortal}`;
        },
        visitStore() {
            this.$inertia.visit(
                route("store", { tab: "frequent", user: this.user.id })
            );
        },
        addCreditCard() {
            this.$inertia.get(route("stripe.update", this.user.id), {
                onSuccess: (result) => {
                    console.log(result);
                    this.loading = false;
                },
                onError: (errors) => {
                    console.log(errors);
                    this.loading = false;
                },
            });
        },
        redrawVueMasonry() {
            for (let i = 0; i <= 300; i += 50) {
                setTimeout(() => {
                    this.$redrawVueMasonry();
                }, i);
            }
        },
    },
    updated() {
        setTimeout(() => {
            this.$redrawVueMasonry();
        }, 300);
    },
};
</script>
